export class BreakdownImportModel {
    counter: number = 0;
    quotationDetailId: number = 0;
    consecutiveQuotation: number = 0;
    articleCode: number = 0;
    articleName: string = "";
    quantity: number = 0;
    unitValue?: number = 0;
    discountRate?: number = 0;

    constructor(
        counter: number = 0,
        quotationDetailId: number = 0,
        consecutiveQuotation: number = 0,
        articleCode: number = 0,
        articleName: string = "",
        quantity: number = 0,
        unitValue: number = 0,
        discountRate: number = 0
    ) {
        this.counter = counter;
        this.quotationDetailId = quotationDetailId;
        this.consecutiveQuotation = consecutiveQuotation;
        this.articleCode = articleCode;
        this.articleName = articleName;
        this.quantity = quantity;
        this.unitValue = unitValue;
        this.discountRate = discountRate;
    }
}